require("core-js/features/promise");
import { DefaultLoaderFactory } from "../../inpulse/Loaders/DefaultLoaderFactory";
import { INotificator } from "../../inpulse/Notificators/INotificator";
import { BootstrapNotificator } from "../../inpulse/Notificators/BootstrapNotificator";
import { ILoaderFactory } from "../../inpulse/Loaders/ILoader";
import { DefaultFeedbackService } from "../../../Areas/Feedback/Scripts/Default/FeedbackService";
import { DefaultContractService } from "../../vue-components/mycontracts/ContractService";
import { MyInformationApiService } from "../../../Areas/eServices/Scripts/Default/MyInfomationApi/MyInformationApiService";
import { AjaxCallerTs } from "../../Default/AjaxCallerTsImplementation/AjaxCaller";
import { ICustomershipViewModel, IAccountInfoViewModel, IEnerityContactPersonViewModel } from "../../inpulse/I4UViewModels";


declare var window: any;
declare var userAccesses: UserAccesses;
declare var apiUrl: string;

declare interface UserAccesses {
    readAccessContacts: boolean;
    readAccessReadingEntry: boolean;
    readAccessContracts: boolean;
}

window._notificator = new BootstrapNotificator();
declare interface Window {
    root: any;
    _notificator: INotificator;
    _lf: ILoaderFactory;
    FeedbackService: DefaultFeedbackService;
    ContractService: DefaultContractService;
}

const feedbackApiUrl = window.location.origin + "/api/feedback";
const myInformationApiUrl = window.location.origin + "/eservices/api/MyInformationApi";
window._lf = new DefaultLoaderFactory();
window.FeedbackService = new DefaultFeedbackService(feedbackApiUrl, null, null, document.getElementsByClassName("unread-messages"), document.getElementsByClassName("unknown-unread-messages"));
window.ContractService = new DefaultContractService(apiUrl, document.getElementById("follow-up-contract-count"));
window.MyInformationService = new MyInformationApiService(new AjaxCallerTs(myInformationApiUrl, false));

function AddCustomerLinkItems(customers: ICustomershipViewModel[]): void {
    const $container = $("#enerityUserMenuItems");
    $container.empty();

    if (customers === null || customers.length < 1) {
        return;
    }
    
    const templateModel = { MyCustomers: customers };
    //console.log(templateModel); Print only when debugging
    const $template = $("#link-item-template");
    $template.tmpl(templateModel).appendTo($container);
}
function AddContactPersonLinkItems(contactPersons: IEnerityContactPersonViewModel[]): number {
    if (contactPersons === null || contactPersons.length < 1) {
        return;
    }

    const templateModel = { ContactPersons: contactPersons };
    //console.log(templateModel); Print only when debugging
    const $container = $("#enerityUserMenuItems");
    const $template = $("#link-item-template_contact_person");
    $template.tmpl(templateModel).appendTo($container);
}

function ProcessLinkItems(accountInfo: IAccountInfoViewModel) {
    if ((accountInfo.MyCustomers === null || accountInfo.MyCustomers.length < 1) &&  (accountInfo.ContactPersons === null || accountInfo.ContactPersons.length < 1)) {
        console.log("No Enerity links");
        $("#enerityMenu").hide();
        return;
    }
    $("#enerityMenu").show();
    AddCustomerLinkItems(accountInfo.MyCustomers);
    AddContactPersonLinkItems(accountInfo.ContactPersons);
}

$(function () {
    if (userAccesses.readAccessContacts === true) {
        window.FeedbackService.ShowMyUnreadMessagesCount();
    }
    if (userAccesses.readAccessContracts) {
        const followUpOffers = window.ContractService.GetFollowUpOffers();
        window.ContractService.ShowFollowUpProcessesCount(followUpOffers);
    }
    //Enerity links
    const enerityMenu = $("#enerityUserMenu").html();
    if (enerityMenu !== undefined) { //Exists only when user is authorized and has access to contracts
        console.log("Generate Enerity links");
        const service = window.MyInformationService;
        let internalResult: IAccountInfoViewModel;
        service.GetEnerityCustomerLinks().Success(function (result) {
            internalResult = result;
        }).ValidationFailure(function (r) {
            //self.notificationUtils.showErrorMessage("Tietojenhaku epäonnistui!");
        }).SystemError(function (r) {
            //self.notificationUtils.showErrorMessage("Tietojenhaku epäonnistui!");
        }).Failure(function (r) {
            //self.notificationUtils.showErrorMessage("Tietojenhaku epäonnistui!");
        }).Finished(function () {
            if (internalResult !== undefined && internalResult !== null) {
                ProcessLinkItems(internalResult);
            }
        });
    }
});



